import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import Store from 'redux/Store'
import setMessage from 'shared/redux/actions/setMessage'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  setIsRequestLoading: Function
  selectedUsers: any
  setError: Function
  handleModalHide: Function
  data: any
}

const submitForm = async (props: submitFormProps) => {
  props.setIsRequestLoading(true)

  let selectedUserIds: any = []

  props.selectedUsers.forEach((selectedUser) => selectedUserIds.push(selectedUser.id))

  props.data['users'] = selectedUserIds

  const formData = {
    ...props.data,
  }

  const response = await axiosPost(
    apiUrls.users + '/' + apiUrls.actionSendEmailMessage,
    formData,
    (err: AxiosError) => {
      switch (err.response!.status) {
        case 422:
          let mappedAttributes: Map<string, string> = new Map()
          mappedAttributes.set('users', 'text')
          setFormValidationError(err, props.setError, mappedAttributes, 'text')
          break
        case 500:
          Store.dispatch(
            setMessage(err.response!.data?.message ?? 'An error occurred', 'error', 'instant'),
          )
          break
        default:
          displayGenError({ setShowOverlay: () => {} })
      }
      return err.response
    },
  ).then((res) => {
    props.setIsRequestLoading(false)
    if (res!.status === 200) {
      const successText =
        selectedUserIds.length > 1 ? 'E-mails have been sent.' : 'E-mail has been sent.'
      Store.dispatch(setMessage(successText, 'success', 'instant'))
      props.handleModalHide()
    }
  })
}

export default submitForm
